import { render, staticRenderFns } from "./AsignacionCargador.vue?vue&type=template&id=b99a1bce"
import script from "./AsignacionCargador.vue?vue&type=script&lang=js"
export * from "./AsignacionCargador.vue?vue&type=script&lang=js"
import style0 from "./AsignacionCargador.vue?vue&type=style&index=0&id=b99a1bce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports